export class GcpStorageAccessConfigurationInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "allowedPrincipals",
            "baseName": "allowedPrincipals",
            "type": "Array<WorkspaceAllowedPrincipalInput>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpStorageAccessConfigurationInput.attributeTypeMap;
    }
    constructor() {
    }
}
